<template>
    <transition name="fade" mode="out-in">
        <section 
            class="padding-vertical-content lightgray-content  mb-3 mb-lg-4" 
            v-if="mostrar" 
            key="pasoSeleccionParcelas"
            id="pasoSeleccionParcelas"
        >
            <div class="container">
                <div class="row">
                    <b-col cols="12">
                        <h2 class="h1 text-uppercase">{{ $t('nuevo_abono.seleccionar_parcelas') }}</h2>
                        <div class="subtitle h3 light mb-3">{{ $t('nuevo_abono.selecciona_zona_parcelas') }}</div>
                    </b-col>
                    <div class="col-12">
                        <ContentOrLoading>
                            <Stepper v-if="!loading" ref="stepper" :steps="steps">
                                <template #subpasoZona="{ changeStep }">
                                    <PasoUno
                                        @terminado="(zona) => { zonaParcelasSeleccionada = zona; changeStep(); }"
                                    />
                                </template>
                                <template #subpasoSeleccionarParcelas="{ changeStep }">
                                    <PasoDosSinBloqueo  
                                        v-if="zonaParcelasSeleccionada"
                                        :zona="zonaParcelasSeleccionada"
                                        :disabled="enviandoAsignaciones || bloquearSVGParcelas"
                                        @terminado="cargarDatosParaMultiselect"
                                        @cambiarZona="() => { zonaParcelasSeleccionada = null; changeStep(true); }"
                                    />
                                </template>
                            </Stepper>

                            <div v-if="mostrarMultiselects" class="mt-4" id="multiselectsParcelas">
                                <h4 class="mb-3">{{ $t('nuevo_abono.asignar_parcelas_abonados') }}</h4>
                                <div v-for="(abono) in abonosComprados" :key="abono.dni">
                                    <div class="mb-4 p-3 border rounded bg-white" v-if="abono.asiento">
                                        <b-row class="align-items-center">
                                            <b-col cols="12" md="4">
                                                <div class="mb-2">
                                                    <div class="mb-1">
                                                        <i class="fas fa-user mr-1"></i>
                                                        <strong>{{ abono.nombre }} {{ abono.apellidos }}</strong>
                                                    </div>
                                                    <div>
                                                        <i class="fas fa-envelope mr-1"></i>
                                                        <small class="text-muted">{{ abono.email }}</small>
                                                    </div>
                                                </div>
                                            </b-col>
                                            <b-col cols="12" md="8">
                                                <label class="form-label">{{ $t('nuevo_abono.seleccionar_parcelas_label') }}</label>
                                                <multiselect
                                                    v-model="abono.parcelasAsignadas"
                                                    :placeholder="$t('nuevo_abono.selecciona_parcelas_placeholder')"
                                                    :custom-label="customLabelParcela"
                                                    label="numero"
                                                    track-by="id"
                                                    :disabled="enviandoAsignaciones"
                                                    :options="parcelasDisponiblesParaAbonado(abono)"
                                                    :multiple="true"
                                                    :show-labels="false"
                                                    @input="procesarAsignacionAutomatica(abono)"
                                                />
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </div>
                        </ContentOrLoading>

                        <div class="mt-4 form-button-responsive">
                            <button 
                                id="continuar-responsive"
                                :class="'button effect-button' + (!esMovil ? ' large-button pb-3' : ' pt-2')"
                                @click="enviarAsignacionesYContinuar"
                                :disabled="!todasLasParcelasAsignadas || enviandoAsignaciones"
                            >
                                <span :style="{ fontSize: esMovil ? '12px' : '16px' }">   
                                    {{ $t('nuevo_abono.continuar') }}
                                </span>
                            </button>
                            <button 
                                id="atras-responsive"
                                :class="'button effect-button ml-2' + (!esMovil ? ' large-button pb-3' : '')"                                         
                                @click="volver"
                                :disabled="enviandoAsignaciones"
                            >
                                <span :style="{ fontSize: esMovil ? '12px' : '16px' }">
                                    {{ $t('nuevo_abono.atras') }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import PasoUno from '@/components/frontend/parcelas/PasoUno.vue';
    import PasoDosSinBloqueo  from '@/components/frontend/abonos/parcelas/PasoDosSinBloqueo.vue';

    export default {
        name: 'SeleccionParcelas',
        props: {
            mostrar: {
                type: Boolean,
                default: false
            },
            datosCompradores: {
                type: Array,
                required: true
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            sesiones: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                zonaParcelasSeleccionada: null,  
                mostrarMultiselects: false,
                abonoSeleccionado: null,
                parcelasSeleccionadasMultiselect: [],
                abonosComprados: [], 
                parcelasCompradas: [],
                asignacionAbonosConParcelas: [],
                parcelasParaBloquear: [],
                enviandoAsignaciones: false,
                bloquearSVGParcelas: false
                
            }
        },
        methods: {
            cargarDatosParaMultiselect(parcelasSeleccionadas) {
                this.parcelasParaBloquear = [...parcelasSeleccionadas];
                this.abonosComprados = this.datosCompradores.map( abono => ({
                    ...abono,
                    parcelasAsignadas: [] 
                }));
                
                this.parcelasCompradas = [...parcelasSeleccionadas];
                this.mostrarMultiselects = true;
                if (this.abonosComprados.length === 1) {
                    const abonoUnico = this.abonosComprados[0];
                    abonoUnico.parcelasAsignadas = [...parcelasSeleccionadas];
        
                    this.procesarAsignacionAutomatica(abonoUnico);
                }

                setTimeout(() => {
                    this.$scrollTo('#multiselectsParcelas', 500);
                }, 500);
            },

            customLabelAbono(option) {
                return `${option.nombre} ${option.apellidos} - ${option.tipo_abono?.nombre || 'Abono'}`;
            },
            
            customLabelParcela(option) {
                return `Parcela Nº ${option.numero} - ${this.$n(option.precioSeleccionado?.precio || 0, "currency")}`;
            },

            asignacion() {
                if(!this.abonoSeleccionado || this.parcelasSeleccionadasMultiselect.length === 0) {
                    this.$toast.error('Por favor, seleccione un abonado y al menos una parcela para asignarle'); 
                    return;
                }

                const asignacion = {
                    abono: { ...this.abonoSeleccionado }, 
                    parcelas: [...this.parcelasSeleccionadasMultiselect]
                }

                this.asignacionAbonosConParcelas.push(asignacion); 
                
                this.abonosComprados = this.abonosComprados.filter(abono => abono.dni !== this.abonoSeleccionado.dni);
                
                this.parcelasCompradas = this.parcelasCompradas.filter(parcela => 
                    !this.parcelasSeleccionadasMultiselect.some(p => p.id === parcela.id)
                );

                this.abonoSeleccionado = null;
                this.parcelasSeleccionadasMultiselect = [];
            },

            async enviarAsignacionesYContinuar() {
                if (!this.todasLasParcelasAsignadas) {
                    if (this.asignacionAbonosConParcelas.length === 0) {
                        this.$toast.error('Debe realizar al menos una asignación antes de continuar');
                    } else {
                        this.$toast.error(`Faltan por asignar ${this.parcelasRestantes}. Todas las parcelas seleccionadas deben ser asignadas.`);
                    }
                    return;
                }

                const sesionIds = this.sesiones ? this.sesiones.map(sesion => sesion.id) : [];

                this.enviandoAsignaciones = true;
                try {
                    const sessions = sesionIds.map((sesionId, indiceSesion) => {
                        const asignacionParaEstaSesion = this.asignacionAbonosConParcelas[indiceSesion];
                        
                        const parcelasParaEstaSesion = asignacionParaEstaSesion ? 
                            asignacionParaEstaSesion.parcelas.map(parcela => ({
                                id: parcela.id,
                                precio_id: parcela.precioSeleccionado?.id,
                            })) : [];

                        return {
                            id: sesionId,
                            parcelas: parcelasParaEstaSesion
                        };
                    });

                    const params = {
                        session_id: sessionStorage.getItem('session_id'),
                        lista_abonado_id: this.$store.getters.getListaAbonados.id,
                        sessions: sessions,
                    }
                    
                    const response  = await this.$store.dispatch('BACK_ABONO_ONLINE_PARCELA_VINCULAR', params)
                   
                    this.bloquearSVGParcelas = true;

                    const parcelasParaResumen = this.asignacionAbonosConParcelas.reduce((acc, asignacion) => {
                        const parcelasFormateadas = asignacion.parcelas.map(parcela => ({
                            id: parcela.id,
                            numero: parcela.numero,
                            zona_nombre: this.zonaParcelasSeleccionada?.nombre || 'Zona',
                            precioSeleccionado: parcela.precioSeleccionado,
                            abonado: {
                                nombre: asignacion.abono.nombre,
                                apellidos: asignacion.abono.apellidos,
                                dni: asignacion.abono.dni
                            }
                        }));
                        acc.push(...parcelasFormateadas);
                        return acc;
                    }, []);
                    
                    this.$emit('continuar', {
                        cart_ids: response.data.cart_ids || [],
                        jet_id: response.data.jet_id || null,
                        datos_parcelas_resumen: parcelasParaResumen,
                    });

                } catch (error) {
                    this.$toast.error('Parcelas ocupadas. Inténtelo de nuevo.');
                    this.volver();
                } 
            },

            volver() {
                this.limpiarTodo();
                this.$emit('volver');
            },

            limpiarTodo() {
                this.zonaParcelasSeleccionada = null;
                this.mostrarMultiselects = false;
                this.abonoSeleccionado = null;
                this.parcelasSeleccionadasMultiselect = [];
                this.abonosComprados = [];
                this.parcelasCompradas = [];
                this.asignacionAbonosConParcelas = [];
                this.enviandoAsignaciones = false;
                this.parcelasParaBloquear = [];
                this.bloquearSVGParcelas = false;
            },

            parcelasDisponiblesParaAbonado(abonadoActual) {
                const parcelasAsignadasAOtros = this.abonosComprados
                    .filter(abono => abono.dni !== abonadoActual.dni)
                    .reduce((acc, abono) => {
                        if (abono.parcelasAsignadas) {
                            acc.push(...abono.parcelasAsignadas.map(p => p.id));
                        }
                        return acc;
                    }, []);

                const parcelasEnAsignaciones = this.asignacionAbonosConParcelas
                    .filter(asignacion => asignacion.abono.dni !== abonadoActual.dni) 
                    .reduce((acc, asignacion) => {
                        acc.push(...asignacion.parcelas.map(p => p.id));
                        return acc;
                    }, []);

                const todasLasParcelasOcupadas = [...new Set([...parcelasAsignadasAOtros, ...parcelasEnAsignaciones])];

                return this.parcelasCompradas.filter(parcela => 
                    !todasLasParcelasOcupadas.includes(parcela.id)
                );
            },

            procesarAsignacionAutomatica(abono) {
                const indiceAsignacionExistente = this.asignacionAbonosConParcelas.findIndex(
                    asignacion => asignacion.abono.dni === abono.dni
                );

                if (abono.parcelasAsignadas && abono.parcelasAsignadas.length > 0) {
                    const nuevaAsignacion = {
                        abono: { ...abono },
                        parcelas: [...abono.parcelasAsignadas]
                    };

                    if (indiceAsignacionExistente !== -1) {
                        this.$set(this.asignacionAbonosConParcelas, indiceAsignacionExistente, nuevaAsignacion);
                    } else {
                        this.asignacionAbonosConParcelas.push(nuevaAsignacion);
                    }
                } else {
                    if (indiceAsignacionExistente !== -1) {
                        this.asignacionAbonosConParcelas.splice(indiceAsignacionExistente, 1);
                    }
                }
            },
            habilitarSVGParcelas(){
                this.bloquearSVGParcelas = false;
                this.enviandoAsignaciones = false;
            }
        },
        computed: {
            totalParcelasSeleccionadas(){
                return this.parcelasParaBloquear.length;
            },

            totalParcelasAsignadas(){
                return this.asignacionAbonosConParcelas.reduce((total, asignacion) =>{
                    return total + asignacion.parcelas.length;
                }, 0);
            },

            todasLasParcelasAsignadas(){
                return this.totalParcelasAsignadas === this.totalParcelasSeleccionadas && this.totalParcelasSeleccionadas > 0;
            },
            parcelasRestantes() {
                return this.totalParcelasSeleccionadas - this.totalParcelasAsignadas;
            },
            steps() {
                return [
                    {label: this.$t('parcelas.selecciona_region'), slot: "subpasoZona"},
                    {label: this.$t('parcelas.selecciona_parcelas'), slot:"subpasoSeleccionarParcelas"}
                ]
            }
        },
        components: {
            Stepper,
            PasoUno,
            PasoDosSinBloqueo 
        }
    }
</script>

